import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface HttpErrorStrategy {
  handleError(error: HttpErrorResponse, caught: Observable<unknown>): Observable<never>;
}
